/** 管理端驳回/拒绝原因预设（点击追加到原因栏） */

export const REJECT_REASON_PRESETS = {
  /** 课程、测评等内容审核 */
  content: [
    '内容不完整或质量不足',
    '封面/缩略图不符合要求',
    '标题或简介不规范',
    '定价不合理',
    '含有不当或违规内容',
    '疑似侵权或未经授权',
    '知识点/题目结构有误',
    '请按站内规范修改后重新提交'
  ],
  /** 头像/相册图片审核 */
  image: [
    '照片模糊不清',
    '请上传清晰正面照',
    '照片含有不当内容',
    '非本人照片',
    '请勿使用卡通或风景图作为头像',
    '照片角度或裁剪不当'
  ],
  /** 用户资料变更审核 */
  profile: [
    '昵称含有不当信息',
    '简介含有广告或违规内容',
    '资料填写不真实',
    '照片不符合要求',
    '请完善必填信息后重新提交'
  ],
  /** 身份证审核 */
  idcard: [
    '身份证图片模糊不清',
    '身份证照片不完整',
    '身份证已过期',
    '身份证信息与用户输入不符',
    '身份证照片疑似伪造',
    '身份证反光严重无法识别',
    '提供的不是身份证照片',
    '身份证照片角度不正确',
    '身份证信息无法识别',
    '重复提交审核'
  ],
  /** 提现拒绝 */
  withdraw: [
    '银行卡信息有误',
    '未完成实名认证',
    '账户信息与实名不符',
    '申请金额异常，请核实',
    '请补充收款账户证明材料'
  ],
  /** 银行转账充值单据拒绝 */
  recharge: [
    '转账金额与单据不符',
    '未查询到对应转账记录',
    '附言/备注信息不匹配',
    '转账凭证不清晰',
    '付款账户信息有误',
    '请核对后重新提交'
  ],
  /** 合伙人申请拒绝 */
  partner: [
    '实名信息不全或有误',
    '暂不符合合伙人条件',
    '申请材料不完整',
    '请补充说明后重新申请'
  ],
  /** 购买申诉退款 */
  refund: [
    '超过申诉期限',
    '消费已正常完成，不予退款',
    '证据不足，请补充说明与凭证',
    '部分服务已使用，无法全额退款'
  ]
}

export function getRejectReasonPresets(category = 'content') {
  return REJECT_REASON_PRESETS[category] || REJECT_REASON_PRESETS.content
}

/** 把预设原因追加进文本；已包含则不动 */
export function appendRejectReason(current, reason) {
  const text = String(current || '').trim()
  const tip = String(reason || '').trim()
  if (!tip) return text
  if (!text) return tip
  if (text.includes(tip)) return text
  return `${text}；${tip}`
}
